import { useCallback } from "react";
import { getReqUrl } from "../../config/reqUrlConfig";
import { SupportedLanguage } from "../../types/Auth";

const useAuthServices = () => {
    const reqUrl = getReqUrl();

    const signIn = useCallback(
        async (email: string, password: string) => {
            const res = await fetch(`${reqUrl}/api/login`, {
                method: 'POST',
                credentials: 'include', // CRUCIAL: accept Set-Cookie and store cookie
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            return res.json(); // server already set HttpOnly cookie
        }, [reqUrl]
    );

    const getSession = useCallback(
        async () => {
            const res = await fetch(`${reqUrl}/api/session`, {
                method: 'POST',
                credentials: 'include', // CRUCIAL: accept Set-Cookie and store cookie
                headers: { 'Content-Type': 'application/json' }
            });

            return res.json();
        }, [reqUrl]
    );

    const signOut = useCallback(
        async () => {
            const res = await fetch(`${reqUrl}/api/logout`, {
                method: 'POST',
                credentials: 'include', // CRUCIAL: accept Set-Cookie and store cookie
                headers: { 'Content-Type': 'application/json' }
            });

            return res.json();
        }, [reqUrl]
    );

    const updateLanguage = useCallback(
        async (language: SupportedLanguage) => {
            const res = await fetch(`${reqUrl}/api/language`, {
                method: 'POST',
                credentials: 'include', // CRUCIAL: accept Set-Cookie and store cookie
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ language })
            });

            return res.json();
        }, [reqUrl]
    );

    return { signIn, getSession, signOut, updateLanguage };
};

export default useAuthServices;
